import { render, staticRenderFns } from "./CommentInput.vue?vue&type=template&id=2270dc84&scoped=true"
import script from "./CommentInput.vue?vue&type=script&lang=js"
export * from "./CommentInput.vue?vue&type=script&lang=js"
import style0 from "./CommentInput.vue?vue&type=style&index=0&id=2270dc84&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2270dc84",
  null
  
)

export default component.exports